import { useTheme } from '@/Hooks'
import React from 'react'
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  ${({ theme }) => css`
    padding-top: ${theme.space.l};
    padding-bottom: ${theme.space.m};
    width: ${theme.size.fill};
  `}
`
const Title = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: ${theme.space.xs};
    height: ${theme.size.s2};
    width: ${theme.size.fill};
  `}
`
const TitleText = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.fontSize.std};
    font-weight: ${theme.fontWeight.semibold};
    color: ${theme.colors.grey3};
  `}
`

const IconWrapper = styled.div`
  ${({ theme }) => css`
    margin-right: ${theme.space.s};
  `}
`

const Bloc = ({
  icon: Icon,
  title,
  children,
  renderIconButton = () => null,
  ...props
}) => {
  const { theme } = useTheme()
  return (
    <Wrapper {...props}>
      <Title>
        {Icon && (
          <IconWrapper>
            <Icon color={theme.colors.grey3} />
          </IconWrapper>
        )}
        <TitleText>{title}</TitleText>
        <div className="grow flex flex-row justify-end">
          {renderIconButton()}
        </div>
      </Title>
      {children}
    </Wrapper>
  )
}
export default Bloc
